smoothly-form {
	display: block;
	position: relative;
}
smoothly-form > form {
	position: relative;
}
smoothly-form > form > fieldset {
	display: flex;
	flex-flow: row wrap;
	margin-inline-start: unset;
	margin-inline-end: unset;
	padding-block-start: unset;
	padding-inline-start: unset;
	padding-inline-end: unset;
	padding-block-end: unset;
	min-inline-size: unset;
	border-width: unset;
	border-style: unset;
	border-color: unset;
	border-image: unset;
}
smoothly-form > form > fieldset > * {
	flex-grow: 1;
	min-width: min(100%, var(--smoothly-form-input-min-width, 14rem));
	flex-basis: 40%;
}

smoothly-form[looks="line"] > form > fieldset,
smoothly-form[looks="border"] > form > fieldset,
smoothly-form[looks="transparent"] > form > fieldset {
	row-gap: var(--smoothly-form-row-gap, 2rem);
	column-gap: var(--smoothly-form-column-gap, 2rem);
}
smoothly-form[looks="grid"] > form > fieldset {
	padding: 1px;
	gap: 1px;
}

smoothly-form > form > div:not(:empty) {
	display: flex;
	justify-content: end;
	gap: 1em;
	margin-top: 1.5rem;
}
